module.exports = __webpack_public_path__ + "img/hr-green-asterisk-16.eb08b336.png";